// gameText.js
// All exact player-facing copy for the main room, ported verbatim from
// escape_peace-old/room.php (stageTexts / stageEndTexts / modal markup).
// Kept centralized so components never hardcode strings — see Section 2A of
// documentation/escape-to-inner-peace-react-conversion-plan.md for the source.

export const ROOM_OBJECT_IDS = ['mirror', 'book', 'tablet', 'safe', 'chest'];

// Story/clue popup text shown before each activity (PHP: stageTexts)
export const CLUE_TEXT = {
  mirror:
    'I appear as who you are, yet I do not define you. To unlock my secrets, find a way to your reflection.',
  book:
    'You have unlocked the mirror’s truth, but clarity is still clouded. Thoughts tangle like jumbled letters in a book, hiding the key to peace. Seek the pages where words await—unravel their order to quiet the storm.',
  tablet:
    'The clutter is cleared, your focus restored,\nYet the screen still holds you, making you sore.\nLook away, take a break, just for a while,\nWhat habit helps your eyes revive?',
  safe:
    'Three keys you hold, but choose with care,\nFor self-love grows with actions rare.\nClick the vault, unlock your way,\nYour future self has much to say!',
  chest:
    'The past is written, and the future awaits. Seek the chest and find four words of truth to open the gates.',
};

// Learning popup text shown after each activity is submitted (PHP: stageEndTexts)
export const LEARNING_TEXT = {
  mirror:
    'Learning: Not all self-talk is beneficial. Choosing positive affirmations helps unlock self-awareness.',
  book: 'Learning: Mindfulness helps in organizing thoughts and reducing overthinking.',
  tablet: 'Learning: Frequent breaks improve focus and well-being.',
  safe: 'Learning: Small actions today build long-term well-being.',
  chest: 'Learning: True self-worth is built on inner qualities, not external validation.',
};

// Activity 1 — Mirror (PHP: #myModal, .statement-button)
export const MIRROR_PROMPT = 'Select 3 statements that you must say to empower yourself';
export const MIRROR_STATEMENTS = [
  { id: 1, text: 'I trust myself to make wise decisions', correct: true },
  { id: 2, text: 'I am not smart enough to achieve my goals', correct: false },
  { id: 3, text: 'If things don’t go as planned, I have failed', correct: false },
  { id: 4, text: 'I choose to focus on solutions, not problems', correct: true },
  { id: 5, text: 'Change is too difficult for me', correct: false },
  { id: 6, text: 'I have the strength to overcome any challenge', correct: true },
];

// Activity 2 — Book (PHP: #myModal2, .inputs-container)
export const BOOK_TITLE =
  'A cluttered mind is like a scrambled message. Rearrange the letters of "MEDITATION" to uncover what clears the mind.';
export const BOOK_SUBTITLE =
  "(Click on i for the hint. If you're unsure of the answer, just make one up and move on)";
export const BOOK_FIELDS = [
  { id: 1, answer: 'idea', hint: 'Hint – It helps spark a creative idea' },
  { id: 2, answer: 'mind', hint: 'Hint – It’s all about training the mind' },
  { id: 3, answer: 'time', hint: 'Hint – Meditation allows time for self-reflection' },
  { id: 4, answer: 'team', hint: 'Hint – Building meaningful connections with others' },
];
// QA fix (Bug 2) — room.php's SweetAlert title when the Book activity is
// submitted with any wrong answer, shown before the learning popup.
export const BOOK_CORRECT_ANSWER_TITLE = 'Correct answer';

// Activity 3 — Tablet (PHP: #myModal3, .option-btn)
export const TABLET_QUESTION = 'What is the scientifically proven best way to reduce screen fatigue?';
export const TABLET_OPTIONS = [
  { position: 1, text: 'Lower screen brightness', correct: false },
  { position: 2, text: 'Take a 5-minute break every 30 minutes', correct: true },
  { position: 3, text: 'Close one eye while scrolling', correct: false },
];

// Activity 4 — Safe (PHP: #myModal4, wordcloud.svg)
export const SAFE_TITLE = 'Select self-care actions that you can commit to support your dreams';

// Activity 5 — Chest (PHP: #myModal5, #puzzle-grid)
export const CHEST_TITLE = 'Choose positive traits from the word puzzle that creates positive impact';
export const CHEST_SUBTITLE = '(Kindly find minimum one word from the puzzle)';
export const CHEST_GRID_SIZE = 10;
